import { usePendingTransactionsListener } from 'hooks/app'

export function Updater() {
  usePendingTransactionsListener()

  return null
}
